// extracted by mini-css-extract-plugin
module.exports = {"image-thumbnail":"InputImageWithPreview_image-thumbnail__2NXTO","image-thumbnail-avator":"InputImageWithPreview_image-thumbnail-avator__3PZrq"};